var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVerticalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 4.30001C7.72583 4.30001 7.23335 3.80752 7.23335 3.20001C7.23335 2.59249 7.72583 2.10001 8.33334 2.10001C8.94086 2.10001 9.43334 2.59249 9.43334 3.20001C9.43334 3.80752 8.94086 4.30001 8.33334 4.30001ZM8.33334 9.10001C7.72583 9.10001 7.23335 8.60752 7.23335 8.00001C7.23335 7.39249 7.72583 6.90001 8.33334 6.90001C8.94086 6.90001 9.43334 7.39249 9.43334 8.00001C9.43334 8.60752 8.94086 9.10001 8.33334 9.10001ZM8.33334 13.9C7.72583 13.9 7.23335 13.4075 7.23335 12.8C7.23335 12.1925 7.72583 11.7 8.33334 11.7C8.94086 11.7 9.43334 12.1925 9.43334 12.8C9.43334 13.4075 8.94086 13.9 8.33334 13.9Z",
    fill: "#6B7280",
    stroke: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVerticalIcon);
export default __webpack_public_path__ + "static/media/dotsVerticalIcon.d033d610fcaf79ea1cd30f60cdf1db63.svg";
export { ForwardRef as ReactComponent };